<template>
	<v-autocomplete
		:items="items"
		:label="label"
		:disabled="disabled"
		:multiple="multiple"
		:value="selected"
		:clearable="clearable"
		:error-count="3"
		:prepend-inner-icon="selectedIcon"
		:error-messages="errors || []"
		autocomplete="new-password"
		@input="onInput($event)"
		@change="onChange($event)"
	>
		<template v-slot:item="{ item }">
			<v-icon class="pr-2">{{ `${iconSet}-${item}` }}</v-icon>
            <v-list-item-content v-text="item"></v-list-item-content>
		</template>
	</v-autocomplete>
</template>

<script>
import * as iconsets from '@/datasources/iconsets'

export default {
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		preferred: {
			type: Array,
			default: () => [],
		},
		disabled: Boolean,
		label: String,
		value: [String, Array],
		clearable: Boolean,
		multiple: Boolean,
		useId: Boolean,
		useAlpha3: Boolean,
		iconSet: {
			type: String,
			default: 'fa',
		},
	},
	data() {
		return {
			items: [],
		}
	},
	computed: {
		selected() {
			return this.value
		},
		selectedIcon() {
			if (!this.value) { return undefined }
			const value = Array.isArray(this.value) ? this.value[0] : this.value
			if (!value) { return undefined }

			return `${this.iconSet}-${value}`
		},
	},
	mounted() {
		this.buildItems()
	},
	methods: {
		onInput(event) {
			this.$emit('input', event)
		},
		onChange(event) {
			this.$emit('change', event)
		},
		buildItems() {
			this.items = [...iconsets[this.iconSet]]
		},
	},
}
</script>
